module.exports = __webpack_public_path__ + "static/media/ilha_4.18f563f0.jpg";